export default (title, text, url) => {
  if (navigator.share) {
    navigator.share({
      title: title,
      text: text,
      url: url,
    }).then(() => {
      // console.log('공유완료!');
    }).catch(error => {
      console.log('공유 실패!!', error);
    });

    return true;
  } else {
    return false;
  }
};